/* eslint-disable import/no-anonymous-default-export */

import hePages from './he';
import enPages from './en';

export default {
    he: hePages,
    en: enPages,
};